import { selectUserState } from 'src/lib/features/auth/authSlice';
import { useTypedSelector } from 'src/lib/store/store';
import { useEffect, useState } from 'react';
import { isDefaultPhoto } from '../EntityAvatar';

type Nullable = string | null | undefined;

export const initialsOf = (first: Nullable, last: Nullable) =>
  `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase() || 'DW';

/* Initials unless there is a real photo: the API's default placeholder and
   an image that fails to load both count as no photo. See EntityAvatar. */
export const Avatar = ({
  photo,
  first,
  last,
  className = 'h-7 w-7',
}: {
  photo?: Nullable;
  first?: Nullable;
  last?: Nullable;
  className?: string;
}) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [photo]);

  return !failed && !isDefaultPhoto(photo) ? (
    <img
      src={photo as string}
      alt=''
      aria-hidden='true'
      onError={() => setFailed(true)}
      className={`${className} shrink-0 rounded-full object-cover`}
    />
  ) : (
    <span
      aria-hidden='true'
      className={`${className} grid shrink-0 place-items-center rounded-full bg-brand-navy text-[11px] font-bold text-white`}
    >
      {initialsOf(first, last)}
    </span>
  );
};

const UserInfo = () => {
  const user = useTypedSelector(selectUserState).user;
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ');

  return (
    <span className='flex items-center gap-2 rounded-full border border-border bg-background py-1 pl-1 pr-1 sm:pr-3'>
      <Avatar photo={user?.photo} first={user?.firstName} last={user?.lastName} />
      <span className='hidden max-w-[9rem] truncate text-sm font-medium text-brand-navy sm:block'>
        {name || 'My profile'}
      </span>
    </span>
  );
};

export default UserInfo;
